import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-poll-block-screen',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './poll-block-screen.component.html',
  styleUrls: ['./poll-block-screen.component.scss'],
})
export class PollBlockScreenComponent implements OnChanges, AfterViewInit {
  @ViewChild('pinInput') pinInput?: ElementRef<HTMLInputElement>;

  @Input() validatingPin = false;
  @Input() resendLoading = false;
  @Input() resendCooldownSeconds = 60;
  @Input() validationError = '';

  @Output() validatePin = new EventEmitter<string>();
  @Output() resendCode = new EventEmitter<void>();

  readonly pinControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d{6}$/),
  ]);

  ngAfterViewInit(): void {
    this.pinInput?.nativeElement.focus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['validatingPin']) {
      if (this.validatingPin) {
        this.pinControl.disable({ emitEvent: false });
      } else {
        this.pinControl.enable({ emitEvent: false });
        this.pinInput?.nativeElement.focus();
      }
    }
  }

  get pinDigits(): string[] {
    const value = this.pinControl.value ?? '';
    const digits: string[] = [];
    for (let index = 0; index < 6; index += 1) {
      digits.push(value[index] ?? '');
    }
    return digits;
  }

  get resendLabel(): string {
    return this.resendCooldownSeconds > 0
      ? `Reenviar codigo (${this.resendCooldownSeconds}s)`
      : 'Reenviar codigo';
  }

  get canSubmit(): boolean {
    return this.pinControl.valid && !this.validatingPin;
  }

  onPinInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const onlyDigits = input.value.replace(/\D/g, '').slice(0, 6);
    this.pinControl.setValue(onlyDigits, { emitEvent: true });
  }

  onSubmitPin(): void {
    if (!this.canSubmit) {
      this.pinControl.markAsTouched();
      return;
    }

    this.validatePin.emit(this.pinControl.value as string);
  }

  onResendCode(): void {
    if (this.resendLoading || this.resendCooldownSeconds > 0) {
      return;
    }

    this.resendCode.emit();
  }

  resetPin(): void {
    this.pinControl.setValue('');
  }
}
